// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D0-9","delete":"styles_delete__2eTot","update":"styles_update__fZIpO","add":"styles_add__2_bVE"};